export default "__VITE_ASSET__ImTX2urK__"